import { ItemSelectorProps } from '../components/Selector/selector.type';
import { InitialConfiguration } from '../interfaces';
import { ProductDurationsProps, VehicleModel } from './interfaces';

/**
 * This function returns the id of the provider model according to the vehicleModels data.
 * @param vehicleModels 
 * @param config 
 * @returns {number | undefined}
 */
export const getIdFromVehicleModels = (
    vehicleModels: Array<VehicleModel>,
    config: InitialConfiguration,
): number | undefined => {
    const selectedVehicle = vehicleModels.find((model) => model.name === config.model);
    return selectedVehicle?.id;
};

/**
 * This function return any property of trimLineDetails 
 * from vehicleModels data.
 * @returns undefined | if not exists.
 */
export const getPropValueFromVehicleModelsTrimLineDetails = (
    vehicleModels: Array<VehicleModel>,
    config: InitialConfiguration,
    prop: string,
    noVersionMatch?: boolean,
): number | undefined => {
    try {
        if (noVersionMatch) {
            return vehicleModels
                .find((model) => transformText(model.name) === transformText(config.model))
                ?.trimLines[0]?.trimLineDetails[0]?.[prop];
        } else {
            return vehicleModels
                .find((model) => transformText(model.name) === transformText(config.model))
                ?.trimLines.find(
                    (trimLine) => trimLine.modelYear === Number(config.year),
                )
                ?.trimLineDetails.find(
                    (version) =>
                        transformText(version.name) ===
                        transformText(config.version),
                )?.[prop];
        }
    } catch (error) {
        return undefined;
    }
};

/**
 * This function transform and return an array type ItemSelectorProps
 * from an Array<ProductDurationsProps>;
 * @param data Array<ProductDurationsProps>
 * @returns Array<ItemSelectorProps>
 */
export const buildIAnItemSelectorArray = (
    data: Array<ProductDurationsProps>,
): Array<ItemSelectorProps> => {
    return data
        .sort((current, product) => current.duration - product.duration)
        .map((duration) => {
            return {
                id: duration.id,
                value: `${duration.duration} meses`,
                valueNumber: duration.duration,
                minimumDownPayment: duration.minimumDownPayment,
                maximumDownPayment: duration.maximumDownPayment,
            };
        });
};

/**
 * This return a transformed text.
 * @param text string.
 * @returns string.
 */
export const transformText = (text: string): string => {
    return text.replace(/\s/g, '').toLowerCase();
};
